const prefix = "PROVIDER_";

export const AUTOCOMPLETE = prefix + "AUTOCOMPLETE";
export const EXPORT = prefix + "EXPORT";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const SAP_TEST_READING = prefix + "SAP_TEST_READING";
export const SAP_TEST_WRITING = prefix + "SAP_TEST_WRITING";
export const VIEW = prefix + "VIEW";
export const RISK_PROFILE_HELP = prefix + "RISK_PROFILE_HELP";
export const RISK_PROFILE_VSL = prefix + "RISK_PROFILE_VSL";
export const RISK_PROFILE_UPFRONT = prefix + "RISK_PROFILE_UPFRONT";
